/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_Points_AgainstInputs */

const th_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เสีย`)
};

const en_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PA`)
};

const ja_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失点`)
};

const zh_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失分`)
};

const es_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC`)
};

const pt_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC`)
};

const id_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PL`)
};

const fr_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC`)
};

const tl_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PL`)
};

const vi_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ĐT`)
};

const ko_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실점`)
};

const de_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PG`)
};

const ru_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПП`)
};

const tr_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YS`)
};

const it_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PS`)
};

const pl_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PS`)
};

const uk_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПП`)
};

const hi_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विअं`)
};

const ar_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عليه`)
};

const ms_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MT`)
};

const bn_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিপ`)
};

const zh_tw2_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失分`)
};

const zh_hk2_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失分`)
};

const ur_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خ`)
};

const fa_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دریافتی`)
};

const sw_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PD`)
};

const nl_col_points_against = /** @type {(inputs: Col_Points_AgainstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PT`)
};

/**
* | output |
* | --- |
* | "PA" |
*
* @param {Col_Points_AgainstInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const col_points_against = /** @type {((inputs?: Col_Points_AgainstInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_Points_AgainstInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_col_points_against(inputs)
	if (locale === "ja") return ja_col_points_against(inputs)
	if (locale === "zh") return zh_col_points_against(inputs)
	if (locale === "es") return es_col_points_against(inputs)
	if (locale === "pt") return pt_col_points_against(inputs)
	if (locale === "id") return id_col_points_against(inputs)
	if (locale === "fr") return fr_col_points_against(inputs)
	if (locale === "tl") return tl_col_points_against(inputs)
	if (locale === "vi") return vi_col_points_against(inputs)
	if (locale === "ko") return ko_col_points_against(inputs)
	if (locale === "de") return de_col_points_against(inputs)
	if (locale === "ru") return ru_col_points_against(inputs)
	if (locale === "tr") return tr_col_points_against(inputs)
	if (locale === "it") return it_col_points_against(inputs)
	if (locale === "pl") return pl_col_points_against(inputs)
	if (locale === "uk") return uk_col_points_against(inputs)
	if (locale === "hi") return hi_col_points_against(inputs)
	if (locale === "ar") return ar_col_points_against(inputs)
	if (locale === "ms") return ms_col_points_against(inputs)
	if (locale === "bn") return bn_col_points_against(inputs)
	if (locale === "zh-TW") return zh_tw2_col_points_against(inputs)
	if (locale === "zh-HK") return zh_hk2_col_points_against(inputs)
	if (locale === "ur") return ur_col_points_against(inputs)
	if (locale === "fa") return fa_col_points_against(inputs)
	if (locale === "sw") return sw_col_points_against(inputs)
	if (locale === "nl") return nl_col_points_against(inputs)
	return en_col_points_against(inputs)
});